import { DeepReadonly } from '@/scenarios/legacy-player/lib/deepReadonly';
import { useInstanceEffect } from '@/scenarios/legacy-player/hooks/useInstanceEffect';

import { Source } from '../types/config';

export const useOnSourceChanged = (
    onSourceChanged: (newSource: DeepReadonly<Source> | undefined) => void
) => {
    useInstanceEffect((instance) => instance.onSourceChange(onSourceChanged), [onSourceChanged]);
};
